//@ts-nocheck
import clsx from "clsx";
import styles from './section-name.module.css'
import { useTheme } from "../../utils/theme";

export default function SectionName({sectionName, normal = "section", dynamic = true, lightMode = false}) {

    const { theme } = useTheme();
    // Use passed lightMode prop if explicitly set, otherwise fall back to theme
    const resolvedLightMode = lightMode !== false ? lightMode : theme === "light";

    return (
        <>
            {sectionName && (<div className={clsx("sectionName", styles[normal], {[styles.light] : resolvedLightMode && dynamic})}>{sectionName}</div>)}
        </>
    )
}